module.exports = "./img/80cd8754ccafc2261c3e7ee4687317e8.jpg";